<template lang="pug">
    div
        Row
            Select(
                :not-found-text="$t('main.selectNotFoundText')"
                :placeholder="$t('main.selectPlaceholder')"
                 :value="$store.state.dashboard.queryFilter.dateRangeOptions.index"
                 @on-change="updateDateRangeOptionsIndex"
            )
                Option(
                    v-for="item in timerangeOptionsI18",
                    :value="item.value",
                    :key="item.value"
                ) {{ item.label }}
        Row
            DatePicker(
                ref="datePicker"
                v-show="$store.state.dashboard.queryFilter.dateRangeOptions.index == '99'"
                :type="type"
                :format="format"
                :placeholder="$t('main.selectTimePlaceholder')"
                style="width: 280px;"
                :time-picker-options="{steps: [1, 1, 60]}"
                :options="datePickerOptions"
                :value="$store.state.dashboard.queryFilter.dateRangeOptions.customTimeRange"
                @on-change="handleManualInput"
            )
</template>

<script>
import { getLicenseInfoOption } from "@/api/system.js";
import moment from "moment";

export default {
    name: "DateRangeSelector",
    components: {},
    props: {
        type: { type: String, default: "datetimerange" },
        format: { type: String, default: "yyyy-MM-dd HH:mm" },
        customTimeRangeOptions: { type: Array },
        dateRangeLimit: { type: Number, default: 90 },
    },
    watch: {},
    data() {
        return {
            datePickerOptions: {
                disabledDate: this.isDateDisabled,
            },
            timerangeOptions: [],
        };
    },
    computed: {
        timerangeOptionsI18() {
            return this.timerangeOptions.map((option) => ({
                label: this.$i18n.t("home." + option.label),
                value: option.value,
            }));
        },
    },
    methods: {
        emitInput() {
            this.$emit("input", this.value);
        },
        updateDateRangeOptionsIndex(value) {
            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "dateRangeOptions.index", value: value });
        },
        updateDateRangeOptionsCustomTimeRange(value) {
            this.$nextTick(() => {
                this.$store.commit("SET_DASHBOARD_QUERY_FILTER", {
                    key: "dateRangeOptions.customTimeRange",
                    value: value,
                });
            });
        },
        isDateDisabled(date) {
            let endOfDayMillionSeconds = moment().endOf("day").valueOf();
            let dayInMillionSeconds = 24 * 60 * 60 * 1000;
            return (
                (date && date.valueOf() < endOfDayMillionSeconds - dayInMillionSeconds * this.dateRangeLimit) ||
                (date && date.valueOf() > endOfDayMillionSeconds)
            );
        },
        handleManualInput(value) {
            // 抓取 endDate (當前日期，時間設為 23:59) endOf('day') 會自動設為 23:59:59
            const endDate = moment().endOf("day");

            // 抓取 startDate 從 endDate 往前推 dateRangeLimit-1 天，並將時間設為 00:00
            const startDate = moment(endDate)
                .subtract(this.dateRangeLimit - 1, "days")
                .startOf("day");

            // 格式化輸出 (使用您要的 HH:mm:ss 格式)
            const format = "YYYY-MM-DD HH:mm:ss";

            const minDate = startDate.format(format);
            const maxDate = endDate.format(format);

            const correctedDate = this.adjustDateRange(value, minDate, maxDate);

            this.updateDateRangeOptionsCustomTimeRange(correctedDate);
        },
        adjustDateRange(dateRange, minAllowedDateStr, maxAllowedDateStr) {
            let message = "";
            const minAllowedTime = new Date(minAllowedDateStr).getTime();
            const maxAllowedTime = new Date(maxAllowedDateStr).getTime();

            const startTime = new Date(dateRange[0]).getTime();
            const endTime = new Date(dateRange[1]).getTime();

            let correctedStartTime = Math.max(startTime, minAllowedTime);
            let correctedEndTime = Math.min(endTime, maxAllowedTime);

            // 確保修正後的 EndTime，也絕對不早於修正後的 StartTime
            if (correctedEndTime < correctedStartTime) {
                correctedEndTime = maxAllowedTime;

                // (可選) 您可以在這裡追加一個特定的提示訊息
                const newline = message !== "" ? "<br>" : "";
                message += `${newline}End date was adjusted to be after start date.`;
            }

            // 修正後的 EndTime，還是小於 StartTime，調整 StartTime
            if (correctedEndTime < correctedStartTime) {
                correctedStartTime = minAllowedTime;
            }

            if (startTime < minAllowedTime) {
                message += "<br>Start date is out of range.";
            }

            if (endTime > maxAllowedTime) {
                const newline = message !== "" ? "<br>" : "";
                message += `${newline}End date is out of range.`;
            }

            if (message !== "") {
                this.$Message.warning(message);
            }

            const correctedStartDate = new Date(correctedStartTime);
            const correctedEndDate = new Date(correctedEndTime);

            return [
                moment(correctedStartDate).format("YYYY-MM-DD HH:mm"),
                moment(correctedEndDate).format("YYYY-MM-DD HH:mm"),
            ];
        },
    },
    async mounted() {
        if (this.customTimeRangeOptions) {
            this.timerangeOptions = this.customTimeRangeOptions;
        } else {
            // 在外部請求頁面以外的 DateRangeSelector，暫時都先套用 requestSummary 的 time options
            await getLicenseInfoOption().then((res) => {
                this.timerangeOptions = res.data.mapData.requestSummary.value;
            });
        }
    },
    watch: {
        customTimeRangeOptions: function (newVal, oldVal) {
            // console.log("Prop changed: ", newVal, " | was: ", oldVal);
            this.timerangeOptions = newVal;
        },
    },
    destroyed() {},
    beforeDestroy() {},
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/DateRangeSelector.vue